























/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { getMessageById } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlSelect',
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    itemText: {
      type: String,
      default: 'text',
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
  }),
  computed: {
    localState: {
      get() {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      },
    },
    rules() {
      if ('readonly' in this.$attrs && this.$attrs.readonly !== false) return [];
      // 必須チェックを判断
      if (this.required) {
        if (this.returnObject) {
          return [
            (value: string) =>
              Object.keys(value).length > 0 || getMessageById('KI_W007'),
          ];
        } else {
          return [
            (value: any) =>
              this.items.findIndex(
                (i: any) => value == i[this.itemValue] || value == i
              ) > -1 || getMessageById('KI_W007'),
          ];
        }
      }
      return [];
    },
  },
  methods: {
    handleDelete() {
      if (this.required) {
        return;
      }
      this.localState = {};
    },
  },
});
